import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTCLIENT_SCHEMA_LITERAL = {
    title: 'Schéma ArtClients',
    description: 'Décrit les spécificités tarifaires',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        AC_CATEGORIE: { type: 'number' },
        AC_PRIXVEN: { type: 'number' },
        AC_COEF: { type: 'number' },
        AC_PRIXTTC: { type: 'number' },
        AC_ARRONDI: { type: 'number' },
        CT_NUM: { type: 'string' },
        AC_REMISE: { type: 'number' },
        AC_CALCUL: { type: 'number' },
        AC_TYPEREM: { type: 'number' },
        AC_QTEMONT: { type: 'number' },
        AC_REFCLIENT: { type: 'string' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'AC_CATEGORIE', 'AC_PRIXVEN' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTCLIENT_SCHEMA_LITERAL);
export type RxFArtClientDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTCLIENT_SCHEMA: RxJsonSchema<RxFArtClientDocumentType> = F_ARTCLIENT_SCHEMA_LITERAL;
